import { Link } from "react-router-dom";
import { useTranslation } from "../hooks/useTranslation";

const NotFound = () => {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-black">
      <h1 className="text-4xl font-bold text-red-500">{t("notFound")}</h1>
      <p className="text-white mt-2">{t("notFoundSorry")}</p>
      <Link to="/" className="mt-4 px-4 py-2 bg-blue-500 text-white rounded">
        {t("notFoundGoHome")}
      </Link>
    </div>
  );
};

export default NotFound;
